var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigateDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6925 2.69283C11.1025 2.28278 11.1025 1.61795 10.6925 1.2079C10.2824 0.797853 9.61759 0.797853 9.20754 1.2079L5.95 4.46544L2.69246 1.2079C2.28241 0.797853 1.61759 0.797853 1.20754 1.2079C0.797487 1.61795 0.797487 2.28278 1.20754 2.69283L5.20754 6.69283C5.61759 7.10288 6.28241 7.10288 6.69246 6.69283L10.6925 2.69283Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateDown);
export default __webpack_public_path__ + "static/media/navigate_down.59b01f66be5c2d982db9c813db424ca2.svg";
export { ForwardRef as ReactComponent };